"use client";
import AngleLeftIcon from "@/assets/icons/arrow-left.svg?react";
import AngleRightIcon from "@/assets/icons/arrow-right.svg?react";
import NoImageSrc from "@/assets/images/no_image.svg";
import { MediaItem } from "@/common/lib/types";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { cn } from "@/lib/tailwind";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { getLangFromLocale } from "@/utils/common";
import { combineAltTextWithImageInfo } from "@/utils/product.utils";
// import Image from "next/image";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
import { Carousel, Slide } from "../ui/carousel/Carousel";
import { ImageStyle } from "./ProductCard";
import style from "./style.module.css";
import CldImage from "../ui/cldImg/CldImage";

interface IProps {
  altText: string;
  productImages: MediaItem[];
  productImageStyle: ImageStyle;
  isNudgeAnimationPresent?: boolean;
  resetImageCarousel?: boolean;
  handleSetResetProductImageCarousel?: (val: boolean) => void;
}
const ProductImageCarousel = ({
  productImages,
  productImageStyle,
  altText,
  isNudgeAnimationPresent,
  resetImageCarousel,
  handleSetResetProductImageCarousel,
}: IProps) => {
  const { locale } = useParams();
  const lang = getLangFromLocale(locale as string);

  // states
  const [inView, setInView] = useState<number[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  // hooks
  const { ref, isIntersecting } = useIntersectionObserver();

  useEffect(() => {
    if (isIntersecting) setIsVisible(true);
  }, [isIntersecting]);

  return (
    <div ref={ref} className={cn("h-full flex-1 md:hidden")}>
      <Carousel
        onSildesInView={(slidesInView) => {
          setInView(slidesInView);
        }}
        onScrollSnap={() => {
          handleSetResetProductImageCarousel?.(false);
        }}
        parentClasses="h-full flex flex-col justify-between "
        paginationControls={{
          classname: "mt-0 ",
          showPaginationOnAfterIndex: true,
        }}
        carouselOptions={{
          loop: true,
        }}
        spacing={22}
        autoPlay={{
          playOnInit: false,
        }}
        shouldScrollToStart={resetImageCarousel}
        slides={productImages.map(
          (image, idx) =>
            ({
              slideClasses: cn(
                `flex basis-full items-center bg-tertiary-5`,
                isNudgeAnimationPresent ? `${style["nudge"]}` : "",
              ),
              content:
                inView.indexOf(idx) > -1 && isVisible ? (
                  <CldImage
                    src={image?.url ? getCloudinaryURL(image.url) : NoImageSrc}
                    alt={altText}
                    width={productImageStyle.width || 300}
                    height={productImageStyle.height || 300}
                    className="h-auto w-full invert-[2%]"
                    loading="lazy"
                  />
                ) : (
                  <></>
                ),
            }) as Slide,
        )}
        controls={{
          distance: "-34px",
          left: {
            content: (
              <div className="hidden p-2 md:block">
                <AngleLeftIcon />
              </div>
            ),
          },
          right: {
            content: (
              <div className="hidden p-2 md:block">
                <AngleRightIcon />
              </div>
            ),
          },
        }}
        assumeSingleSlideInView={true}
      />
    </div>
  );
};

export default ProductImageCarousel;
